import { render, staticRenderFns } from "./LoftRow.vue?vue&type=template&id=65195fe2&scoped=true&"
import script from "./LoftRow.vue?vue&type=script&lang=js&"
export * from "./LoftRow.vue?vue&type=script&lang=js&"
import style0 from "./LoftRow.vue?vue&type=style&index=0&id=65195fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65195fe2",
  null
  
)

export default component.exports